import React, { useState } from "react";

const SocialMedia: React.FC = () => {
  const [selectedPlatform, setSelectedPlatform] = useState<string>("instagram");
  const [selectedContentType, setSelectedContentType] =
    useState<string>("posts");
  const [selectedAccount, setSelectedAccount] =
    useState<string>("amqoth_bharath_");
  const [playLatest, setPlayLatest] = useState<boolean>(false);
  const [latestPostsCount, setLatestPostsCount] = useState<number>(5);
  const [playSelected, setPlaySelected] = useState<boolean>(true);

  // Live URL states
  const [liveUrl, setLiveUrl] = useState<string>("");
  const [loginId, setLoginId] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [isEnabled, setIsEnabled] = useState<boolean>(true);

  return (
    <div className="mb-8">
      <div className="flex gap-6 mt-5">
        {/* Left Side - Platform Selection */}
        <div className="w-1/4">
          <h3 className="text-lg font-semibold mb-4 text-gray-700">Platform</h3>
          <div className="space-y-3">
            {/* Instagram Card */}
            <div
              className={`p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 ${
                selectedPlatform === "instagram"
                  ? "border-blue-400 bg-blue-50"
                  : "border-gray-200 bg-white hover:border-gray-300"
              }`}
              onClick={() => setSelectedPlatform("instagram")}
            >
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 mb-2">
                  {/* Instagram Logo */}
                  <img
                    src={"/assets/images/instagram-logo.png"}
                    alt="Instagram Logo"
                    className="w-full h-full object-contain"
                  />
                </div>
                <span className="text-sm font-medium text-gray-700">
                  Instagram
                </span>
              </div>
            </div>

            {/* Live URL Card */}
            <div
              className={`p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 ${
                selectedPlatform === "liveurl"
                  ? "border-blue-400 bg-blue-50"
                  : "border-gray-200 bg-white hover:border-gray-300"
              }`}
              onClick={() => setSelectedPlatform("liveurl")}
            >
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 mb-2 flex items-center justify-center">
                  {/* Link Icon */}
                  <img
                    src={"/assets/images/youtube-logo.png"}
                    alt="YouTube Play Button"
                    className="w-full h-full object-contain"
                  />
                </div>
                <span className="text-sm font-medium text-gray-700">
                  Live URL
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Content Configuration */}
        <div className="flex-1">
          {selectedPlatform === "instagram" ? (
            // Instagram Content Settings
            <>
              <h3 className="text-lg font-semibold mb-4 text-gray-700">
                Content Settings
              </h3>

              {/* Content Type Tabs */}
              <div className="flex mb-6">
                <button
                  className={`px-10 py-2 rounded-l-lg border border-gray-300 transition-colors duration-200 ${
                    selectedContentType === "posts"
                      ? "bg-blue-500 text-white border-blue-500"
                      : "bg-white text-gray-700 hover:bg-gray-50"
                  }`}
                  onClick={() => setSelectedContentType("posts")}
                >
                  Posts
                </button>
                <button
                  className={`px-10 py-2 rounded-r-lg border border-gray-300 border-l-0 transition-colors duration-200 ${
                    selectedContentType === "reels"
                      ? "bg-blue-500 text-white border-blue-500"
                      : "bg-white text-gray-700 hover:bg-gray-50"
                  }`}
                  onClick={() => setSelectedContentType("reels")}
                >
                  Reels
                </button>
              </div>

              {/* Account Selection */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Account
                </label>
                <select
                  value={selectedAccount}
                  onChange={(e) => setSelectedAccount(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="amqoth_bharath_">amqoth_bharath_</option>
                  <option value="another_account">another_account</option>
                  <option value="test_account">test_account</option>
                </select>
              </div>

              {/* Playback Options */}
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3">
                    <input
                      type="checkbox"
                      id="playLatest"
                      checked={playLatest}
                      onChange={(e) => setPlayLatest(e.target.checked)}
                      className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                    />
                    <label
                      htmlFor="playLatest"
                      className="text-sm font-medium text-gray-700"
                    >
                      Play
                    </label>
                  </div>
                  <div className="flex items-center space-x-2">
                    <input
                      type="number"
                      value={latestPostsCount}
                      onChange={(e) =>
                        setLatestPostsCount(parseInt(e.target.value))
                      }
                      className="w-16 px-2 py-1 border border-gray-300 rounded text-center text-sm"
                      min="1"
                      max="50"
                    />
                    <span className="text-sm text-gray-600">Latest Posts</span>
                  </div>
                </div>

                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="playSelected"
                    checked={playSelected}
                    onChange={(e) => setPlaySelected(e.target.checked)}
                    className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  />
                  <label
                    htmlFor="playSelected"
                    className="ml-3 text-sm font-medium text-gray-700"
                  >
                    Play selected posts
                  </label>
                </div>
              </div>
            </>
          ) : (
            // Live URL Configuration
            <>
              <div className="flex justify-between items-start mb-6">
                <h3 className="text-lg font-semibold text-gray-700">
                  Live URL Configuration
                </h3>
                <input
                  type="checkbox"
                  checked={isEnabled}
                  onChange={(e) => setIsEnabled(e.target.checked)}
                  className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
              </div>

              {/* Input Fields */}
              <div className="space-y-4 mb-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Live URL :
                  </label>
                  <input
                    type="text"
                    value={liveUrl}
                    onChange={(e) => setLiveUrl(e.target.value)}
                    placeholder="Type OR Paste URL"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div className="flex gap-4">
                  <div className="flex-1">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Login ID :
                    </label>
                    <input
                      type="text"
                      value={loginId}
                      onChange={(e) => setLoginId(e.target.value)}
                      placeholder="Login"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                  <div className="flex-1">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Password :
                    </label>
                    <input
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Password"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                </div>
              </div>

              {/* Video Preview Area */}
              <div className="grid grid-cols-2 gap-4">
                {/* Left Preview - Placeholder */}
                <div className="border border-gray-300 rounded-lg p-4">
                  <div className="w-full h-32 bg-gray-100 rounded flex items-center justify-center mb-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-12 h-12 text-gray-400"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                      />
                    </svg>
                  </div>
                  <div className="text-xs text-gray-600 mb-1">
                    https://pub.movingwa
                  </div>
                  <div className="inline-block px-2 py-1 bg-gray-200 rounded text-xs font-mono">
                    00:00:00
                  </div>
                </div>

                {/* Right Preview - YouTube Live */}
                <div className="border border-gray-300 rounded-lg p-4">
                  <div className="w-full h-32 bg-black rounded relative flex items-center justify-center mb-2">
                    {/* YouTube-style thumbnail */}
                    <div className="absolute inset-0 bg-gradient-to-br from-red-600 to-red-800 rounded flex items-center justify-center">
                      <div className="absolute top-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded">
                        आज तक
                      </div>
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="white"
                            className="w-8 h-8 ml-1"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347c-.75.412-1.667-.13-1.667-.986V5.653Z"
                            />
                          </svg>
                        </div>
                      </div>
                      <div className="absolute bottom-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded">
                        LIVE...
                      </div>
                    </div>
                  </div>
                  <div className="text-xs text-gray-600 mb-1">
                    https://www.youtube.
                  </div>
                  <div className="inline-block px-2 py-1 bg-gray-200 rounded text-xs font-mono">
                    00:00:00
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SocialMedia;
